
import React, { useState, useEffect } from 'react';
import { getTrans as t } from "../../Localization/translations";
import Tooltip from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { ToastContainer, toast } from "react-toastify";
import DocumentUpload from '../../services/document/documentupload';
import Helper from '../../Helper';
import { useLocation } from 'react-router-dom';

function Doc() {
    const [documents, setDocuments] = useState([]);
    const location = useLocation();
    const { reference_id, reference_name } = location.state;
    const [selectedFile, setSelectedFile] = useState(null);
    const [title, setTitle] = useState('');
    const [fileDescription, setFileDescription] = useState('');
    const [tags, setTags] = useState(reference_name);
    const [searchTerm, setSearchTerm] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorFile, setErrorFile] = useState('');
    const [errorTitle, setErrorTitle] = useState('');

    useEffect(() => {
        if (searchTerm === '') {
            DocumentUpload.viewListuploadFilterview(reference_name,reference_id).then((res) => {
                console.log("res", res)
                setDocuments(res.data.data)
            }).catch((e) => {
                console.log('e', e)
            })
        }
    }, [searchTerm]);

    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            const file = e.target.files[0];
            setSelectedFile(file);
        }
    };

    const handleUpload = async () => {
        if (!selectedFile) {
            setErrorFile("Please Select a File");
            return;
        }

        if (!title.trim()) {
            setErrorTitle("Please Enter a Title");
            return;
        }

        setLoading(true);
        setErrorFile('');
        setErrorTitle('')

        const formData = new FormData();
        formData.append('title', title);
        formData.append('description', fileDescription);
        formData.append('tags', tags);
        formData.append('reference_id',reference_id)
        formData.append('reference_name',reference_name)
        formData.append('file', selectedFile);
        if (reference_name === 'AchReturn') {
        formData.append('doc_type', 'AchReturn');
    }

        try {
            DocumentUpload.excelfileDocument(formData).then((response) => {
                const newDocument = {
                    id: response.data.id || documents.length + 1,
                    name: selectedFile.name,
                    size: (selectedFile.size / 1024).toFixed(2) + ' KB',
                    date: new Date().toLocaleString(),
                    tags: tags,
                    type: selectedFile.name.split('.').pop()
                };
                console.log('newDocument', newDocument)
                setDocuments([...documents, newDocument]);

                setSelectedFile(null);
                setTitle('');
                setFileDescription('');
                setTags('');

                toast.success('Document uploaded successfully!', {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                })
            })

        } catch (err) {
            toast.error("Failed to upload document. Please try again.", {
                position: "top-right",
                autoClose: 1000,
                hideProgressBar: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            })
        } finally {
            setLoading(false);
        }
    };

    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchTerm(value);
    };

    const handleSearch = () => {
        if (searchTerm.trim()) {
            setLoading(true);
            DocumentUpload.viewListuploadFilter(searchTerm)
                .then(response => {
                    setDocuments(response.data.data);
                    setLoading(false);
                })
                .catch(error => {
                    setLoading(false);
                });
        } else {
            setDocuments([]);
            setSearchTerm('')
        }
    }


    const hanldeTitleChange = (e) => {
        let value = e.target.value
        setTitle(e.target.value)
        if (value !== '') {
            setErrorTitle('')
        }
    }

    const handleDownload = (fileUrl) => {
        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const [currentPage, setCurrentPage] = useState(1);
    const recordsPerPage = 5;

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentDocuments = documents.slice(indexOfFirstRecord, indexOfLastRecord);

    const totalPages = Math.ceil(documents.length / recordsPerPage);

    const handleNext = () => {
        if (currentPage < totalPages) {
            setCurrentPage(prev => prev + 1);
        }
    };

    const handlePrevious = () => {
        if (currentPage > 1) {
            setCurrentPage(prev => prev - 1);
        }
    };

    return (
        <div className="content container-fluid">
            <ToastContainer />
            <div className="header">
                <h4 className='mb-3 mt-3'>Documents</h4>
                <div className="search-container row">
                    <div className="col-md-6">
                        <input
                            type="text"
                            placeholder="Search document"
                            value={searchTerm}
                            className='form-control'
                            onChange={(e) => handleSearchChange(e)}
                        />
                    </div>
                    <div className='col-md-2'>
                        <button
                            className="btn-continue border-0 btn btn-primary btn-gradient-primary btn"
                            onClick={handleSearch}
                        >
                            Search
                        </button>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-md-8">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="mb-3">{t("Upload Document")}</h5>
                            <div className="form-group">
                                <label className="col-form-label">Select a file</label>
                                <div className="file-input-wrapper">
                                    <input
                                        type="file"
                                        onChange={handleFileChange}
                                        className="form-control"
                                        id="file-input"
                                    />
                                    {selectedFile && (
                                        <div className="selected-file mt-2">
                                            {selectedFile.name} ({(selectedFile.size / 1024).toFixed(2)} KB)
                                        </div>
                                    )}
                                </div>
                                <div className="invalid-feedback">
                                    {errorFile && errorFile}
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="col-lg-6 col-form-label">
                                    {t("Title")}{" "}
                                    <Tooltip content={t("Title_Tooltip") || "Enter document title"}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                </label>
                                <input
                                    type="text"
                                    value={title}
                                    className="form-control"
                                    onChange={(e) => hanldeTitleChange(e)}
                                    placeholder="Document title"
                                />
                                <div className="invalid-feedback">
                                    {errorTitle && errorTitle}
                                </div>
                            </div>

                            <div className="form-group">
                                <label className="col-lg-6 col-form-label">
                                    {t("Description")}{" "}
                                    <Tooltip content={t("Description_Tooltip")}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                </label>
                                <textarea
                                    value={fileDescription}
                                    onChange={(e) => setFileDescription(e.target.value)}
                                    rows="8"
                                    style={{ height: '120px' }}
                                    className="form-control"
                                    placeholder="Document description"
                                />
                            </div>

                            <div className="form-group">
                                <label className="col-lg-6 col-form-label">
                                    {t("Tags")}{" "}
                                    <Tooltip content={t("Tags_Tooltip") || "Comma-separated tags"}>
                                        <i className="fa fa-light fa-circle-info"></i>
                                    </Tooltip>
                                </label>
                                <input
                                    type="text"
                                    value={tags}
                                    className="form-control"
                                    onChange={(e) => setTags(e.target.value)}
                                    placeholder="Enter tags separated by commas"
                                />
                                <p className="selected-file mt-2">Ex: report, finance, 2025</p>
                            </div>

                            <button
                                className="btn-continue border-0 btn btn-primary btn-gradient-primary btn"
                                onClick={handleUpload}
                                disabled={loading || !selectedFile}
                            >
                                {loading ? "Uploading..." : "Upload Document"}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card">
                        <div className="card-body">
                            <h5 className="mb-3">Documents ({documents.length})</h5>
                            <div className="documents-list">
                                {currentDocuments && currentDocuments.map(doc => (
                                    <div className="document-item" key={doc.id}>
                                        <div className="document-icon">
                                            {doc.type === 'pdf' ? '📄' :
                                                doc.type === 'doc' || doc.type === 'docx' ? '📝' :
                                                    doc.type === 'jpg' || doc.type === 'jpeg' || doc.type === 'png' ? '🖼️' :
                                                        '📁'}
                                        </div>
                                        <div className="document-info">
                                            <div className="document-name">{doc.title}</div>
                                            <div className="document-metadata">
                                                {Helper.DateNormal(doc.uploaded_at)}
                                            </div>
                                            <div className="document-tags">
                                                {doc.tags.split(',').map((tag, index , arr) => (
                                                    <span key={index} className="tag-pill">{tag.trim()}{index < arr.length - 1 ? ', ' : ''}</span>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="document-actions">
                                            <button className="btn-continue border-0 btn btn-primary btn-gradient-primary btn"
                                                onClick={() => handleDownload(doc.file)}
                                            >
                                                Download
                                            </button>
                                        </div>
                                    </div>
                                ))}
                                <div className="pagination-controls d-flex justify-content-between mt-3">
                                    <button
                                        className="pag-btn"
                                        onClick={handlePrevious}
                                        disabled={currentPage === 1}
                                    >
                                        Previous
                                    </button>

                                    <span>Page {currentPage} of {totalPages}</span>

                                    <button
                                        className="pag-btn"
                                        onClick={handleNext}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Doc;